import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Avatar,
  Button,
  Toolbar,
  List,
  ListItem,
  Divider,
  ListItemText,
  Tooltip,
  IconButton,
  ClickAwayListener,
  Typography,
  Box,
  Link
} from '@material-ui/core';
import HeaderImage from '../Icons/enphase-logo.png';
import settings from '../../../utils/settings';
import clsx from 'clsx';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { get, keysIn, includes } from 'lodash';
import { enlightenHomeownerLinks, forwardTo, getCountryBasedLink } from '../../../utils/helper';
import StoreIcon from '../Icons/StoreIcon';
import HelpIcon from '../Icons/HelpIcon';
import Account from '../Icons/Account';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import MenuIcon from '@material-ui/icons/Menu';
import User from '../Icons/User';
import { ACCOUNT_DETAILS } from '../../Breadcrumb/constant';
import { removeKey } from '../../../utils/localStorage';
import I18n from '../../../config/locales';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: '#0F0F0F !important',
    borderRadius: '0px !important',
    boxShadow: theme.shadows[1],
    fontSize: '11px !important',
    padding: '0px !important',
    top: theme.spacing(-1),
    minWidth: theme.spacing(30),
    pointerEvents: 'auto'
  },
  arrow: {
    color: `${theme.palette.secondary.main} !important`
  },
  popper: {}
}))(Tooltip);

const styles = theme => ({
  root: {
    display: 'flex',
    background: `${theme.palette.primary.main} !important`,
    flexDirection: 'row',
    boxShadow: 'none !important',
    zIndex: 11,
    position: 'fixed'
  },
  large: {
    width: `${theme.spacing(15)}px !important`,
    height: 'auto !important'
  },
  navigation: {
    fontSize: '16px !important',
    margin: `${theme.spacing(1)}px !important`,
    color: `${theme.palette.secondary.main} !important`,
    fontWeight: '400 !important',
    textTransform: 'none !important'
  },
  toolbar: {
    padding: '0 !important',
    minHeight: '0 !important',
    [theme.breakpoints.down('md')]: {
      padding: '3px 0px !important'
    }
  },
  headerToolbar: {
    margin: `${theme.spacing(0, 4)} !important`
  },
  active: {
    fontWeight: '700 !important'
  },
  mobileToolbar: {
    padding: '0px !important',
    minHeight: '0 !important',
    flexDirection: 'row-reverse',
    flexGrow: 1
  },
  menuIcon: {
    cursor: 'pointer !important',
    color: `${theme.palette.secondary.main} !important`
  },
  menuStore: {
    width: theme.spacing(4),
    height: theme.spacing(3)
  },
  fullList: {
    width: theme.spacing(25),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },
  menuList: {
    justifyContent: 'space-evenly'
  },
  rightSection: {
    marginLeft: 'auto !important',
    padding: '0 !important',
    minHeight: '0 !important'
  },
  mobileMenuIcon: {
    color: theme.palette.secondary.dark
  },
  iconButton: {
    padding: '0 !important',
    marginRight: `${theme.spacing(4.5)}px !important`,
    borderRadius: '0 !important',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  userWrapper: {
    display: 'flex',
    alignItems: 'center',
    background: '#EAEAEA 0% 0% no-repeat padding-box',
    padding: theme.spacing(1, 2)
  },
  user: {
    color: '#0F0F0F !important',
    fontSize: '20px !important'
  },
  userIcon: {
    width: `${theme.spacing(9)}px !important`,
    height: `${theme.spacing(9)}px !important`
  },
  link: {
    fontSize: '16px !important',
    color: `${theme.palette.tertiary.main} !important`,
    padding: `${theme.spacing(1)}px  !important`,
    borderBottom: '1px solid #70707036 !important',
    '&:last-child': {
      border: 'none !important'
    }
  },
  accountWrapper: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column'
  },
  logout: {
    fontSize: '16px !important',
    color: '#0f0f0f9e !important',
    cursor: 'pointer !important'
  },
  accountRoot: {
    display: 'flex',
    flexDirection: 'column'
  },
  tooltipRootWrapper: {
    padding: theme.spacing(1)
  },
  mobileUserWrapper: {
    order: 1,
    flexDirection: 'column'
  },
  mobileAccountWrapper: {
    order: 0
  },
  userDetails: {
    marginLeft: theme.spacing(2)
  },
  mobileUserDetails: {
    marginLeft: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mobileAccountDetailsLink: {
    border: 'none',
    borderTop: '1px solid #70707036',
    '&:last-child': {
      borderTop: '1px solid #70707036'
    }
  },
  mobileIconButton: {
    marginRight: 0
  },
  listItemWrapper: {
    padding: `${theme.spacing(1, 2)} !important`
  }
});

class HomeownerHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      accountDropdownOpen: false
    };
  }

  handleAccountDropdown = isOpen => {
    this.setState({ accountDropdownOpen: isOpen });
  };

  trackEvent = googleAnalyticsName => {
    const dataLayer = {
      menuValue: googleAnalyticsName
    };
    this.gaAnalytics.triggerEvent({ event: 'triggerMyProfile' }, dataLayer);
  };

  toggleDrawer() {
    this.setState({ open: !this.state.open });
  }

  redirect(menu, isInternal = false) {
    switch (menu) {
      case 'account':
        forwardTo('/manager/account/account-details');
        return;
      default:
        break;
    }
    let url;
    if (isInternal) {
      url = settings.enlightenMenuUrl(menu);
      window.location.replace(url);
    } else {
      if (menu === 'enstore') url = getCountryBasedLink('enphaseStore');
      else if (menu === 'help') url = getCountryBasedLink('enlightenHelp');
      window.open(url, '_blank');
    }
  }

  getEnlightenUrl(menu, key) {
    return get(enlightenHomeownerLinks(), `${menu}.${key}`);
  }

  accountDetails = (isMobile = false) => {
    const { classes, accountDetail } = this.props;
    const { first_name: firstname, last_name: lastname } = accountDetail;
    const pathName = window.location.pathname.includes('dashboard') ? 'dashboard' : 'account';
    let rootClass = classes.tooltipRootWrapper;
    let userWrapper = classes.userWrapper;
    let accountWrapper = classes.accountWrapper;
    let userDetails = classes.userDetails;
    let accountDetailsLink = classes.link;
    if (isMobile) {
      rootClass = clsx(rootClass, classes.accountRoot);
      userWrapper = clsx(userWrapper, classes.mobileUserWrapper);
      accountWrapper = clsx(accountWrapper, classes.mobileAccountWrapper);
      userDetails = classes.mobileUserDetails;
      accountDetailsLink = clsx(accountDetailsLink, classes.mobileAccountDetailsLink);
    }
    return (
      <ClickAwayListener onClickAway={() => this.handleAccountDropdown(false)}>
        <Box className={rootClass}>
          <Box className={userWrapper}>
            <User className={classes.userIcon} />
            <Box className={userDetails}>
              <Typography className={classes.user} id="userName">{`${firstname} ${lastname}`}</Typography>
              <Typography
                className={classes.logout}
                component="div"
                onClick={() => {
                  removeKey('_enlighten_manager_token');
                  removeKey('_solargraf_token');
                  removeKey('referrer');
                  this.redirect('logout', true);
                }}
                id="logOut"
              >
                {I18n.t('header.logOut')}
              </Typography>
            </Box>
          </Box>
          <Box className={accountWrapper}>
            {ACCOUNT_DETAILS.map(account => {
              let url = account.isBasePath ? account.url : `/manager/${pathName}/${account.url}`;
              return (
                <Link
                  key={account.label}
                  className={accountDetailsLink}
                  to={url}
                  component={RouterLink}
                  onClick={e => {
                    this.trackEvent(account.googleAnalyticsName);
                    this.toggleDrawer();
                  }}
                  id={account.label}
                >
                  {I18n.t(`accountInfo.${account.name}`)}
                </Link>
              );
            })}
          </Box>
        </Box>
      </ClickAwayListener>
    );
  };

  renderButtons = (index, menu, navClass) => {
    return (
      <Fragment key={index}>
        <Button
          color="primary"
          key={index}
          className={navClass}
          onClick={() => this.onMenuClick(menu)}
          id={`${menu}Icon`}
        >
          {this.getEnlightenUrl(menu, 'name')}
        </Button>
      </Fragment>
    );
  };

  onMenuClick = menu => {
    const menuList = get(enlightenHomeownerLinks(), `${menu}`);
    if (menuList.isExternal) {
      window.open(menuList.url, '_blank');
    } else {
      this.redirect(menuList.url, true);
      this.toggleDrawer();
    }
  };

  renderSideList = (belongsToInMxItFr = false) => {
    const { classes } = this.props;
    return (
      <div className={classes.fullList} role="presentation">
        <List>
          {keysIn(enlightenHomeownerLinks()).map((menu, index) => {
            return (
              <Fragment key={index}>
                <ListItem
                  button
                  key={index}
                  onClick={() => this.onMenuClick(menu)}
                  className={classes.listItemWrapper}
                  id={`${menu}IconMobile`}
                >
                  <ListItemText primary={this.getEnlightenUrl(menu, 'name')} />
                </ListItem>
                <Divider />
              </Fragment>
            );
          })}
          <ListItem button className={clsx(classes.menuList, classes.listItemWrapper)}>
            {!belongsToInMxItFr && (
              <Tooltip title={I18n.t('header.enphaseStore')}>
                <IconButton
                  className={clsx(classes.iconButton, classes.mobileIconButton)}
                  onClick={() => this.redirect('enstore')}
                  id="enphaseStoreIconMobile"
                >
                  <StoreIcon
                    className={clsx(classes.menuIcon, classes.mobileMenuIcon, classes.menuStore)}
                    stroke="#7E7E7E"
                  />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title={I18n.t('header.enphaseSupport')}>
              <IconButton
                className={clsx(classes.iconButton, classes.mobileIconButton)}
                onClick={() => this.redirect('help')}
                id="enphaseSupportIconMobile"
              >
                <HelpIcon className={clsx(classes.menuIcon, classes.mobileMenuIcon)} stroke="#7E7E7E" />
              </IconButton>
            </Tooltip>
          </ListItem>
          <Divider />
        </List>
        {this.accountDetails(true)}
      </div>
    );
  };

  render() {
    const { classes, isMobileView, belongsToIn, belongsToMx, belongsToBr, belongsToIt, belongsToFr } = this.props;
    const enlightenHomeownerKeys = keysIn(enlightenHomeownerLinks());
    const activeTab = enlightenHomeownerKeys.find(key => includes(window.location.pathname, key));
    const belongsToInMxBrItFr = belongsToIn || belongsToMx || belongsToBr || belongsToIt || belongsToFr;
    return (
      <Fragment>
        <AppBar position="static" color="secondary" className={classes.root}>
          <Toolbar className={clsx(classes.headerToolbar, classes.toolbar)}>
            <Avatar variant="square" alt="enphase logo" src={HeaderImage} className={classes.large} id="enphaseLogo" />
          </Toolbar>
          {isMobileView ? (
            <Toolbar className={classes.mobileToolbar}>
              <IconButton className={classes.iconButton} onClick={() => this.toggleDrawer()} id="menuIcon">
                <MenuIcon className={classes.menuIcon} />
              </IconButton>
            </Toolbar>
          ) : (
            <Fragment>
              <Toolbar className={classes.toolbar}>
                {enlightenHomeownerKeys.map((menu, index) => {
                  let navClass = menu === activeTab ? clsx(classes.navigation, classes.active) : classes.navigation;
                  return this.renderButtons(index, menu, navClass);
                })}
              </Toolbar>

              <Toolbar className={classes.rightSection}>
                {!belongsToInMxBrItFr && (
                  <Tooltip title={I18n.t('header.enphaseStore')}>
                    <IconButton
                      id="enphaseStoreIcon"
                      className={clsx(classes.iconButton, classes.menuIcon)}
                      onClick={() => this.redirect('enstore')}
                    >
                      <StoreIcon className={classes.menuStore} />
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title={I18n.t('header.enphaseSupport')}>
                  <IconButton
                    id="enphaseSupportIcon"
                    className={clsx(classes.iconButton, classes.menuIcon)}
                    onClick={() => this.redirect('help')}
                  >
                    <HelpIcon />
                  </IconButton>
                </Tooltip>
                <LightTooltip
                  onClose={() => this.handleAccountDropdown(false)}
                  open={this.state.accountDropdownOpen}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  title={this.accountDetails()}
                  arrow
                  placement="bottom-end"
                >
                  <IconButton
                    className={clsx(classes.iconButton, classes.menuIcon)}
                    onClick={() => this.handleAccountDropdown(!this.state.accountDropdownOpen)}
                    id="accountIcon"
                  >
                    <Account />
                    {this.state.accountDropdownOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                </LightTooltip>
              </Toolbar>
            </Fragment>
          )}
        </AppBar>
        {isMobileView && (
          <SwipeableDrawer
            anchor="right"
            open={this.state.open}
            onClose={() => this.toggleDrawer()}
            onOpen={() => this.toggleDrawer()}
          >
            {this.renderSideList(belongsToInMxBrItFr)}
          </SwipeableDrawer>
        )}
      </Fragment>
    );
  }
}

HomeownerHeader.propTypes = {
	belongsToIn: PropTypes.bool,
  belongsToMx: PropTypes.bool,
  belongsToBr: PropTypes.bool,
  belongsToIt: PropTypes.bool,
  belongsToFr: PropTypes.bool,
  accountDetail: PropTypes.object
};

export default (withStyles(styles)(HomeownerHeader));
